import { createAsyncThunk } from "@reduxjs/toolkit"

import ThunkResponse from "../../models/thunk-response"
import Question from "../../models/question"

import CreateFetchInit from "../../utils/create-fetch-init"
import query from "../../utils/query"
import { endpoints } from "./endpoints"

export const createQuestion = createAsyncThunk<
    ThunkResponse<Question.Create.Response>,
    Question.Create.Payload
>("question/create", async (payload) => {
    try {
        const response = await fetch(
            endpoints.questions,
            CreateFetchInit("POST", payload.body, payload.query.token),
        )

        const status = response.status
        let data: any
        try {
            data = await response.json()
        } catch {}

        return { status, data }
    } catch (e) {
        console.error("Exception thrown in thunk createQuestion", (e as any)?.message)
        return Promise.reject()
    }
})

export const getUserLibrary = createAsyncThunk<
    ThunkResponse<Question.GetLibrary.Response>,
    Question.GetLibrary.Payload
>("question/get-library", async (payload) => {
    try {
        const response = await fetch(
            query(endpoints.questions, ["user", payload.user]),
            CreateFetchInit("GET", undefined, payload.token),
        )

        const status = response.status
        let data: any
        try {
            data = await response.json()
        } catch {}

        return { status, data }
    } catch (e) {
        console.error("Exception thrown in thunk getLibrary", (e as any)?.message)
        return Promise.reject()
    }
})

export const getQuestion = createAsyncThunk<
    ThunkResponse<Question.Get.Response>,
    Question.Get.Payload
>("question/get", async (payload) => {
    try {
        const response = await fetch(
            query(endpoints.questions, ["id", payload.id]),
            CreateFetchInit("GET", undefined, payload.token),
        )

        const status = response.status
        let data: any
        try {
            data = await response.json()
        } catch {}

        return { status, data }
    } catch (e) {
        console.error("Exception thrown in thunk getQuestion", (e as any)?.message)
        return Promise.reject()
    }
})

export const generateTitle = createAsyncThunk<
    ThunkResponse<Question.GenerateTitle.Response>,
    Question.GenerateTitle.Payload
>("question/generate-title", async (payload) => {
    try {
        const response = await fetch(
            endpoints.questionsGenerateTitle,
            CreateFetchInit(
                "POST",
                {
                    questionId: payload.questionId,
                    question: payload.question,
                    answer: payload.answer,
                },
                payload.token,
            ),
        )

        const status = response.status
        let data: any
        try {
            data = await response.json()
        } catch {}

        return { status, data }
    } catch (e) {
        console.error("Exception thrown in thunk generateTitle", (e as any)?.message)
        return Promise.reject()
    }
})
